export default __webpack_public_path__ + "static/media/agilityImage.47d3c0a2.svg";